import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _ViewLiveDemoFilledIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 2C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H11.2314C11.7077 21.469 12 20.7695 12 20V15C12 13.3431 10.6569 12 9 12H4C3.23076 12 2.53098 12.2916 2 12.7676V4C2 2.89543 2.89543 2 4 2H20ZM14 5.22949C13.5858 5.22955 13.25 5.56629 13.25 5.98047C13.2503 6.39442 13.586 6.73041 14 6.73047H16.2021L12.4688 10.4707C12.1768 10.7638 12.177 11.2388 12.4697 11.5312C12.7628 11.8235 13.2387 11.8231 13.5312 11.5303L17.2598 7.79395V9.99023C17.26 10.4042 17.5958 10.7402 18.0098 10.7402C18.4238 10.7402 18.7595 10.4042 18.7598 9.99023V5.98047C18.7598 5.96651 18.7576 5.95225 18.7568 5.93848C18.756 5.92316 18.7557 5.90787 18.7539 5.89258C18.7511 5.86875 18.7471 5.84536 18.7422 5.82227C18.7328 5.77874 18.7205 5.73547 18.7031 5.69336L18.7012 5.69043C18.6988 5.68479 18.6959 5.6794 18.6934 5.67383C18.6775 5.63856 18.6593 5.60508 18.6387 5.57324C18.6322 5.56322 18.6251 5.55363 18.6182 5.54395C18.5975 5.51518 18.5751 5.48823 18.5508 5.46289C18.5439 5.45573 18.5374 5.44829 18.5303 5.44141C18.4669 5.38036 18.3939 5.33055 18.3135 5.29492C18.3017 5.28971 18.2894 5.28587 18.2773 5.28125C18.2471 5.26967 18.2163 5.25957 18.1846 5.25195C18.1668 5.24771 18.1491 5.24319 18.1309 5.24023C18.125 5.23928 18.1192 5.23812 18.1133 5.2373C18.1045 5.23609 18.0958 5.2343 18.0869 5.2334L18.0098 5.22949H14Z"
        fill={iconColor}
      />
      <Path
        d="M9 14C9.55228 14 10 14.4477 10 15V20C10 20.5523 9.55228 21 9 21H4C3.44772 21 3 20.5523 3 20V15C3 14.4477 3.44772 14 4 14H9Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const ViewLiveDemoFilledIcon = assignWithoutSideEffects(_ViewLiveDemoFilledIcon, {
  componentId: 'ViewLiveDemoFilledIcon',
});

export default ViewLiveDemoFilledIcon;
